import React, { FC } from 'react';
import { EntityDecision } from '../../entity/entity.types';
import { Hyperlink } from '../../components/Hyperlink';
import { buildUrlWithParameters } from '../../utils/url-utils/urlUtils';
import styles from './entity_decision_list.module.scss';

type Props = {
  decisions: Array<EntityDecision>;
  source: string;
};

export const EntityDecisionList: FC<Props> = ({ decisions, source }) => (
  <>
    {decisions.map((decision) => (
      <Hyperlink
        href={buildUrlWithParameters(decision.referenceUrl, { source })}
        className={styles.link}
        key={decision.referenceUrl}
      >
        {decision.title}
      </Hyperlink>
    ))}
  </>
);
